export const habaWishlist = {
  wishlistOverview: {
    title: 'Meine Merklisten',
    addNew: 'Neue Merkliste erstellen',
    noWishlists: 'Sie haben keine Merklisten',
    back: 'Meine Merklisten',
    notifyMe:'Benachrichtigen Sie mich',
    navigation: {
      add: 'Erstellen Sie eine neue Merkliste',
      chooseExisting: 'Oder wählen Sie eine vorhandene Merkliste aus',
    },
    list: {
      delete: 'Merkliste löschen',
      moveAllToBasket: 'Alles in den Warenkorb',
      noItems: 'Die Merkliste enthält noch keine Produkte',
      noItemsButton: 'Überprüfen Sie unsere Produkte',
      noItemsButtonMobile: 'Überprüfen Produkte',
    },
    item: {
      quantity: 'Menge: {{quantity}}',
      articleNr: 'Artikelnummer: {{articleNr}}',
      action: {
        cart: ' In den Warenkorb',
        move: 'Artikel verschieben',
        delete: 'Artikel entfernen',
      },
    },
    modal: {
      addedToCart: {
        title: 'Der Artikel wurde zum Warenkorb hinzugefügt',
        btn: 'Zum Warenkorb',
      },
    },
  },
  wishlistCreate: {
    placeholder: 'Name der Merkliste',
    button: 'Neue Merkliste speichern',
    successMessage: 'Merkliste erstellt',
    errorLengthMin: 'Name muss länger als drei Buchstaben sein.',
    errorLengthMax: 'Name muss kürzer als 100 Buchstaben sein.',
    errorExitsAlready: 'Name existiert bereits.',
    errorExitsAlreadyInHabaPlay:
      'Sie haben bereits eine Merkliste mit dem gleichen Namen bei HABA Play. Bitte geben Sie einen anderen Namen für die Merkliste ein.',
    errorCommon: 'Ups, da ist etwas schief gegangen.',
    emptiedListSuccessMessage: 'Ihre Produkte wurden dem Warenkorb hinzugefügt',
    listCreated: 'Merkliste erstellt',
  },
  wishlistEdit: {
    edit: 'Merkliste bearbeiten',
    name: 'Name der Merkliste',
    rename: 'Merkliste umbennen',
    delete: 'Merkliste löschen',
    successMessage: 'Liste bearbeitet',
    questionDelete: 'Möchten Sie diese Liste und alle enthaltenen Produkte löschen?',
  },
  wishlistList: {
    noItems: 'No items available in this list',
    allToBasket: 'Alles in den Warenkorb',
    removedSuccessMessage: 'Die Merkliste wurde gelöscht',
    itemRemovedSuccessMessage: 'Liste aktualisiert',
    deletedList: 'Ihre Merkliste wurde gelöscht',
    renameList: 'Der Name der Merkliste wurde geändert',
  },
  wishlistMove: {
    title: 'Produkt verschieben',
    subtitle: 'Wählen Sie eine Merkliste aus:',
    successMessage: 'Ihr Produkt wurde verschoben',
    warningCartsMessage: 'Sie haben nur 1 Liste ',
    newWishlist: 'Oder erstellen Sie eine neue Merkliste',
  },
  wishlistAdd: {
    title: 'Meine Merklisten',
    newWishlist: 'Erstellen Sie eine neue Merkliste',
    toExisting: 'Oder wählen Sie eine vorhandene Merkliste aus',
    addToWishlist: 'Zur Merkliste hinzufügen',
    addToWishlistTitle: 'Zur Merkliste hinzufügen',
    addToCartSuccess: 'Ihr Produkt wurde dem Warenkorb hinzugefügt',
    warningSelectWishlist: 'Sie müssen zuerst eine Liste auswählen',
    noListsCreatedMessage: 'Sie haben derzeit keine Wunschliste, bitte erstellen Sie eine.',
    createWishlistAltText: 'oder erstellen Sie eine neue Liste',
    addedToWishlist: 'Zur Liste hinzugefügt',
    removeItemFromWishlist: 'Das Produkt wurde von der Merkliste entfernt.',
  },
};
